import React from "react";
import { Col, FormGroup, Row } from "reactstrap";
import { firebaseConnect, isLoaded } from "react-redux-firebase";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { serviceCaller, ServiceCallerProps } from "../../composition";
import isEmpty from "lodash.isempty";

import get from "lodash.get";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { IPost, PostType } from "../../../types/services/IPost";
import { nodeForPostType } from "../../../utils/helpers";
import Select from "react-select";
import { brandSelectTheme } from "../../../toolkit/baseSelect/theme";
import { withRouter } from "../../../utils/withRouter";

interface Props extends ServiceCallerProps {
  currentPost?: {
    post: IPost;
    type: PostType;
  };
  firebase: firebase.app.App;
  firebaseSubCharities: { [s: string]: string };
  canEditPublishing: boolean;
  busyLoading: boolean;
  firebaseSelectedSubCharities?: Array<{ label: string; value: string }>;
  isVisible: boolean;

  updateSubcharities: (
    subCharitiesList: Array<{ label: string; value: string }>
  ) => void;
}

interface State {
  subCharitiesList: Array<{ label: string; value: string }>;
}

class SubCharitiesSection extends React.PureComponent<Props, State> {
  static defaultProps = {
    isVisible: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      subCharitiesList: [],
    };
  }

  componentDidMount() {
    if (this.props.currentPost && this.props.currentPost.post) {
      this.fillPostData();
    }
  }

  fillPostData = () => {
    if (
      !isEmpty(this.props.firebaseSubCharities) &&
      !isEmpty(this.props.firebaseSelectedSubCharities)
    ) {
      let formattedSubCharities = Object.entries(
        this.props.firebaseSubCharities
      ).map(entry => {
        return {
          value: entry[0],
          label: entry[1],
        };
      });

      let selectedSubCharityKeys = Object.keys(
        this.props.firebaseSelectedSubCharities
      );
      let selectedSubCharities = formattedSubCharities.filter(item =>
        selectedSubCharityKeys.includes(item.value)
      );

      this.setState(
        {
          subCharitiesList: selectedSubCharities,
        },
        () => this.props.updateSubcharities(this.state.subCharitiesList)
      );
    }
  };

  getSubCharitiesSelection = () => {
    return this.state.subCharitiesList;
  };

  getOptions = () => {
    return Object.entries(this.props.firebaseSubCharities).map(entry => {
      return { value: entry[0], label: entry[1] };
    });
  };

  handleChange = e => {
    this.setState(
      {
        subCharitiesList: e,
      },
      () => this.props.updateSubcharities(this.state.subCharitiesList)
    );
  };

  render() {
    if (!this.props.isVisible) return null;
    return (
      <Row>
        <Col md={12} sm={12} lg={12} xl={{ size: 8, offset: 2 }}>
          <FormGroup>
            <label className={s.titleLabel} htmlFor="subCharities">
              Select Sub-accounts
            </label>
            <Select
              placeholder="All sub-accounts are default"
              value={this.getSubCharitiesSelection()}
              isMulti
              options={this.getOptions()}
              onChange={this.handleChange}
              maxMenuHeight={200}
              theme={brandSelectTheme}
              styles={{
                menu: provided => ({
                  ...provided,
                  zIndex: "100",
                }),
              }}
            />
          </FormGroup>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { firebase, user } = state;
  const previousPost =
    props.params.postId &&
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(
      firebase.data[user.currentCharity.id][
        nodeForPostType(props.params.postType)
      ]
    ) &&
    isLoaded(
      firebase.data[user.currentCharity.id][
        nodeForPostType(props.params.postType)
      ][props.params.postId]
    )
      ? get(
          firebase,
          `data.${user.currentCharity.id}.${nodeForPostType(
            props.params.postType
          )}.${props.params.postId}`
        )
      : null;

  return {
    currentPost: !previousPost
      ? null
      : {
          post: previousPost,
          type: props.params.postType,
        },
  };
};

export default serviceCaller(
  connect(mapStateToProps)(
    firebaseConnect((props, store) => {
      const result =
        store.getState().user.currentCharity.id !== ""
          ? [
              `${store.getState().user.currentCharity.id}/segments`,
              `${store.getState().user.currentCharity.id}/config/hasApps`,
            ]
          : [];
      if (
        props.params.postType &&
        props.params.postId &&
        store.getState().user.currentCharity.id !== ""
      ) {
        const node = nodeForPostType(props.params.postType);
        result.push(
          `${store.getState().user.currentCharity.id}/${node}/${
            props.params.postId
          }`
        );
      }
      return result;
    })(withStyles(s)(withRouter(SubCharitiesSection)))
  )
);
